import * as React from "react"

const SvgUserFile = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.993 14.57q.825 0 1.412-.587.588-.588.588-1.412 0-.825-.588-1.413a1.93 1.93 0 0 0-1.412-.587q-.825 0-1.413.587a1.93 1.93 0 0 0-.587 1.413q0 .825.587 1.412.588.588 1.413.588Zm4 4v-.574a1.99 1.99 0 0 0-1.225-1.85 7.6 7.6 0 0 0-1.338-.425q-.687-.15-1.437-.15c-.75 0-.98.05-1.438.15q-.687.15-1.337.425a1.99 1.99 0 0 0-1.225 1.85v.575z" />
    <path
      fillRule="evenodd"
      d="M4.588 21.984q.587.587 1.412.587h12q.824 0 1.413-.587A1.93 1.93 0 0 0 20 20.571V9.396a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.588A1.93 1.93 0 0 0 4 4.57v16q0 .825.588 1.413ZM13 4.57v4a.97.97 0 0 0 .287.713q.288.287.713.287h4v11H6v-16z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgUserFile
